export default __webpack_public_path__ + "static/media/natl-camp.7cc602c3.png";